import React, { useState } from 'react';
import { SiteHeader } from '../components/SiteHeader';
import { SiteFooter } from '../components/SiteFooter';
export function Kontakt() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [submitted, setSubmitted] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitted(true);
    setTimeout(() => {
      setFormData({
        name: '',
        email: '',
        subject: '',
        message: ''
      });
      setSubmitted(false);
    }, 3000);
  };
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };
  return <div className="min-h-screen bg-[#f4f2ee] font-sans text-[#1a1a1a] text-[14px]" data-id="element-349">
      <SiteHeader data-id="element-350" />

      <div className="max-w-[900px] mx-auto px-[20px] py-[40px]" data-id="element-351">
        <h1 className="text-[28px] font-bold text-[#1a1a1a] mb-[32px] border-b-[2px] border-[#c8c0b0] pb-[16px]" data-id="element-352">
          Kontakt
        </h1>

        <div className="grid md:grid-cols-2 gap-[24px] mb-[32px]" data-id="element-353">
          <div className="bg-white border border-[#ddd] rounded-[6px] p-[24px]" data-id="element-354">
            <h2 className="text-[18px] font-bold text-[#1a1a1a] mb-[16px]" data-id="element-355">
              Kontaktinformationen
            </h2>

            <div className="space-y-[16px] text-[14px] leading-[1.7]" data-id="element-356">
              <div data-id="element-357">
                <p className="font-semibold text-[15px] mb-[8px]" data-id="element-358">
                  Emerald Health Solutions Ltd.
                </p>
                <p className="text-[#555]" data-id="element-359">
                  Unit 12, Business Centre, Sandyford
                  <br data-id="element-360" />
                  Dublin 18, D18 X2P9
                  <br data-id="element-361" />
                  Irland
                </p>
              </div>

              <div data-id="element-362">
                <p className="font-medium text-[#1a1a1a] mb-[4px]" data-id="element-363">Telefon</p>
                <a href="tel:+35314960123" className="text-[#1a2e4a] hover:underline" data-id="element-364">
                  +353 1 496 0123
                </a>
              </div>

              <div data-id="element-365">
                <p className="font-medium text-[#1a1a1a] mb-[4px]" data-id="element-366">E-Mail</p>
                <a href="mailto:contact@emerald-health.ie" className="text-[#1a2e4a] hover:underline" data-id="element-367">
                  contact@emerald-health.ie
                </a>
              </div>

              <div className="pt-[12px] border-t border-[#e0ddd8]" data-id="element-368">
                <p className="text-[12px] text-[#888]" data-id="element-369">
                  <strong data-id="element-370">Geschäftszeiten:</strong>
                  <br data-id="element-371" />
                  Montag - Freitag: 9:00 - 17:00 Uhr
                  <br data-id="element-372" />
                  Samstag - Sonntag: Geschlossen
                </p>
              </div>
            </div>
          </div>

          <div className="bg-white border border-[#ddd] rounded-[6px] p-[24px]" data-id="element-373">
            <h2 className="text-[18px] font-bold text-[#1a1a1a] mb-[16px]" data-id="element-374">
              Unternehmensdetails
            </h2>

            <div className="space-y-[12px] text-[14px] leading-[1.7]" data-id="element-375">
              <div data-id="element-376">
                <p className="font-medium text-[#1a1a1a]" data-id="element-377">Geschäftsführer</p>
                <p className="text-[#555]" data-id="element-378">Liam O'Connor</p>
              </div>

              <div data-id="element-379">
                <p className="font-medium text-[#1a1a1a]" data-id="element-380">
                  Handelsregisternummer
                </p>
                <p className="text-[#555]" data-id="element-381">742185</p>
              </div>

              <div data-id="element-382">
                <p className="font-medium text-[#1a1a1a]" data-id="element-383">Umsatzsteuer-ID</p>
                <p className="text-[#555]" data-id="element-384">IE9988776W</p>
              </div>
            </div>
          </div>
        </div>

        <div className="bg-white border border-[#ddd] rounded-[6px] p-[24px]" data-id="element-385">
          <h2 className="text-[18px] font-bold text-[#1a1a1a] mb-[16px]" data-id="element-386">
            Kontaktformular
          </h2>

          {submitted ? <div className="bg-[#e8f5e9] border border-[#4caf50] rounded-[4px] p-[16px] text-[14px] text-[#2e7d32]" data-id="element-387">
              Vielen Dank für Ihre Nachricht! Wir werden uns schnellstmöglich
              bei Ihnen melden.
            </div> : <form onSubmit={handleSubmit} className="space-y-[16px]" data-id="element-388">
              <div data-id="element-389">
                <label htmlFor="name" className="block text-[13px] font-medium text-[#1a1a1a] mb-[6px]" data-id="element-390">
                  Name *
                </label>
                <input type="text" id="name" name="name" required value={formData.name} onChange={handleChange} className="w-full border border-[#e0ddd8] rounded-[4px] px-[12px] py-[8px] text-[14px] bg-[#fafaf8] focus:border-[#1a2e4a] focus:outline-none" data-id="element-391" />
              </div>

              <div data-id="element-392">
                <label htmlFor="email" className="block text-[13px] font-medium text-[#1a1a1a] mb-[6px]" data-id="element-393">
                  E-Mail *
                </label>
                <input type="email" id="email" name="email" required value={formData.email} onChange={handleChange} className="w-full border border-[#e0ddd8] rounded-[4px] px-[12px] py-[8px] text-[14px] bg-[#fafaf8] focus:border-[#1a2e4a] focus:outline-none" data-id="element-394" />
              </div>

              <div data-id="element-395">
                <label htmlFor="subject" className="block text-[13px] font-medium text-[#1a1a1a] mb-[6px]" data-id="element-396">
                  Betreff *
                </label>
                <input type="text" id="subject" name="subject" required value={formData.subject} onChange={handleChange} className="w-full border border-[#e0ddd8] rounded-[4px] px-[12px] py-[8px] text-[14px] bg-[#fafaf8] focus:border-[#1a2e4a] focus:outline-none" data-id="element-397" />
              </div>

              <div data-id="element-398">
                <label htmlFor="message" className="block text-[13px] font-medium text-[#1a1a1a] mb-[6px]" data-id="element-399">
                  Nachricht *
                </label>
                <textarea id="message" name="message" required rows={6} value={formData.message} onChange={handleChange} className="w-full border border-[#e0ddd8] rounded-[4px] px-[12px] py-[8px] text-[14px] bg-[#fafaf8] resize-y focus:border-[#1a2e4a] focus:outline-none" data-id="element-400"></textarea>
              </div>

              <div className="flex justify-between items-center pt-[8px]" data-id="element-401">
                <p className="text-[12px] text-[#888]" data-id="element-402">* Pflichtfelder</p>
                <button type="submit" className="bg-[#1a2e4a] text-white border-none rounded-[4px] px-[24px] py-[10px] text-[13px] font-semibold cursor-pointer hover:bg-[#2a3e5a]" data-id="element-403">
                  Nachricht senden
                </button>
              </div>
            </form>}
        </div>

        <div className="bg-[#fff9e6] border border-[#e8c84a] rounded-[6px] p-[20px] mt-[24px]" data-id="element-404">
          <p className="text-[12px] text-[#666] leading-[1.6]" data-id="element-405">
            <strong data-id="element-406">Hinweis:</strong> Für medizinische Notfälle wenden Sie sich
            bitte an Ihren Arzt oder den ärztlichen Notdienst. Dieses
            Kontaktformular dient ausschließlich allgemeinen Anfragen und nicht
            der medizinischen Beratung.
          </p>
        </div>
      </div>

      <SiteFooter data-id="element-407" />
    </div>;
}